import { GetAdminTripResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one trip's admin detail (GET /v1/admin/trips/:id). Disabled until the id
 * is a valid positive number. Gated server-side by AdminGuard; a missing id returns
 * 404.
 */
export const useAdminTrip = (id: number) => {
	return useQuery<GetAdminTripResponse>({
		queryKey: queryKeys.adminTrip(id),
		queryFn: async () => {
			const response = await api.get<GetAdminTripResponse>(`/admin/trips/${id}`)
			return response.data
		},
		enabled: Number.isFinite(id) && id > 0,
	})
}
